// declares rbr action types.

import NotificationsConst from '../constants/notifications.constants';
import NotificationService from '../../services/notification.services';
const service = new NotificationService();

export const NotificationsDeleteAll = (ids) => async (dispatch, getState) => {
  try {
    await service.deleteAllNotifications({ ids })
    dispatch({
      type: NotificationsConst.NOTIFICATIONS_DELETE_ALL,
      item: [],
    })
    await dispatch(NotificationsLoadData())
    toastr?.success('Successfully deleted all notifications')
  }
  catch (e) {
    console.error(e)
    toastr?.error('Failed to delete all notifications')
  }
}

export const NotificationsDeleteRow = (ids, item) => async(dispatch, getState) => {
  try {
    await service.deleteAllNotifications({ ids })
    dispatch({
      type: NotificationsConst.NOTIFICATIONS_DELETE_ROW,
      item,
    })
    toastr?.success('Successfully deleted the notification')
  }
  catch (e) {
    console.error(e)
    toastr?.error('Failed to delete the notification')
  }
}

export const NotificationsAddNew = item => ({
  type: NotificationsConst.NOTIFICATIONS_ADD_NEW,
  item,
});

export const NotificationsFilter = item => ({
  type: NotificationsConst.NOTIFICATIONS_FILTER,
  item,
});

export const NotificationsReactionEmoji = data => ({
  type: NotificationsConst.NOTIFICATIONS_REACTION_EMOJI,
  data,
});

export const NotificationsLoadData = (count = 100, isNew = false) => async(dispatch, getState) => {
  const stateValue = getState();
  // console.log('stateval', stateValue);
  return service.getNotificationData({ limit: count })
    .then((response) => {
      const d = response.data || [];
      if (isNew) {
        dispatch(NotificationsAddNew(d));
      }
      else {
        dispatch({
          type: NotificationsConst.NOTIFICATIONS_LOAD_DATA,
          data: d
        })
      }
    });
}